import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Filter } from 'lucide-react';
import Button from '../../components/ui/Button';

// Başvuru listesinin üstündeki kapsam şeridi.
//
// İki iş yapar:
//   1. KAPSAM SEÇİMİ — `picker` yuvası (ilan seçici). FE-15: 40 açık ilanlı bir
//      kiracıda tek bir ilanı çalışmanın tek yolu İlanlar sayfasına gidip
//      "Başvuruları Gör" demekti; artık liste kendi üzerinden daraltılabiliyor.
//   2. KAPSAM AFİŞİ — İlanlar sayfasının "Başvuruları Gör" (ilan) ve Adaylar
//      sayfasının "Başvuruları" (aday) kapsamını görünür kılar, tek tıkla kaldırır.
//
// Afiş UYGULANAN sorgu parametrelerinden türer (DataTable `filterList`'i yutar —
// çip yolu güvenilir değildir). Şerit, kapsam yokken de `picker` varsa çizilir:
// seçici kaybolup ortaya çıkan bir kontrol olamaz.
const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  margin: 0 0 12px;
  background: ${({ theme }) => theme.colors.bgColor};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: ${({ theme }) => theme.metrics.radius.large};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
`;

const Icon = styled.span`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.primary.main};
`;

const PickerSlot = styled.div`
  min-width: 240px;
  max-width: 320px;
  flex: 0 1 auto;
`;

const Chips = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 6px 18px;
  min-width: 0;
`;

const Chip = styled.span`
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  overflow-wrap: anywhere;
`;

// `statusLabels`: İşe Alım Panosu'nun KPI şeridinden gelen `?status=` kapsamı
// (ör. "Aktif, Beklemede, Teklif Verildi"). Afişte GÖRÜNÜR olması şart: kart 42
// deyip liste 42 satır gösterirken kullanıcının "neden bütün başvurular yok?"
// diye sormaması gerekir — ve "Kapsamı Kaldır" bunu da temizler.
export default function ScopeBanner({ postingTitle, candidateName, statusLabels, onClear, picker }) {
  const { t } = useTranslation();
  const hasScope = !!(postingTitle || candidateName || statusLabels);
  if (!hasScope && !picker) return null;
  return (
    <Bar data-testid="ats-scope-banner" role="status">
      <Icon><Filter size={14} /></Icon>
      {picker && <PickerSlot data-role="ats-posting-picker">{picker}</PickerSlot>}
      <Chips>
        {postingTitle && <Chip>{t('ats.application.scopeBanner.posting', { title: postingTitle })}</Chip>}
        {candidateName && <Chip>{t('ats.application.scopeBanner.candidate', { name: candidateName })}</Chip>}
        {statusLabels && <Chip>{t('ats.application.scopeBanner.status', { statuses: statusLabels })}</Chip>}
      </Chips>
      {hasScope && (
        <Button variant="outline" onClick={onClear}>{t('ats.application.scopeBanner.clear')}</Button>
      )}
    </Bar>
  );
}
